<!-- <p>form-dropdown-templates works!</p> -->
<ng-template let-selectableData #creditCardListTmplt [appControlTemplate]="'creditCardListTmplt'">
    <box class="credit-card-list-item">
        <box class="card-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/credit-card.svg" alt="CC" />
            </box>
            <box class="card-number-info">
                <box class="card-number">{{selectableData?.text?.contractNumber}}</box>
                <box class="credit-limit">
                    <span class="lbl">Avaialable Limit</span>
                    <span class="amount">{{ selectableData?.text?.availableLimit }} <em>{{ selectableData?.text?.currency
                            }}</em></span>
                </box>
            </box>
            
        </box>
       <!-- <box class="card-sec-2">
        </box>-->
    </box>
</ng-template>

<ng-template let-selectableData #creditCardMiniListTmplt [appControlTemplate]="'creditCardMiniListTmplt'">
    <box class="credit-card-list-item">
        <box class="card-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/credit-card.svg" alt="CC" />
            </box>
            <box class="card-number-info">
                <box class="card-number">{{selectableData?.text.contractNumber}}</box>
                <box class="card-type-grp">
                    <span class="card-type">{{selectableData?.text.cardType}}</span>
                    <!-- <span class="card-type-icon"><img
                            [src]="'./assets/images/cards-logo/' + selectableData?.text.cardType.toLocaleLowerCase() + '.svg'"
                            alt="CC" /></span> -->
                </box>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #accountMiniListTmplt [appControlTemplate]="'accountMiniListTmplt'">
    <box class="account-mini-list-item">
        <box class="account-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/account-icon.svg" alt="account" />
            </box>
            <box class="acc-number-info">
                <box class="acc-number">{{selectableData?.text.accountNumber}}</box>
                <box class="acc-type-grp">
                  <span class="acc-type">
                    <span class="amount"> {{ selectableData?.text.availableBalance | currency : selectableData?.text.accountCurrency : '' }}
                      <span class="currency">{{ selectableData?.text.accountCurrency || 'USD' }}</span>
                    </span>
                    |
                    <span class="account-type-desc">
                      {{selectableData?.text.accountTypeDesc}}
                    </span>
                    </span>
                </box>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #debitCardMiniListTmplt [appControlTemplate]="'debitCardMiniListTmplt'">
    <box class="debit-card-list-item">
        <box class="card-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/credit-card.svg" alt="debit-card" />
            </box>
            <box class="card-number-info">
                <box class="card-number">{{selectableData?.text.cardNumber}}</box>
                <box class="card-type-grp">
                    <span class="card-type">{{selectableData?.text.productDesc}}</span>
                    <!-- <span class="card-type-icon"><img
                            [src]="'./assets/images/cards-logo/' + selectableData?.text.cardType.toLocaleLowerCase() + '.svg'"
                            alt="CC" /></span> -->
                </box>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #accountNumberListTmplt [appControlTemplate]="'accountNumberListTmplt'">
    <box class="account-list-item">
        <box class="account-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/account-icon.svg" alt="account" />
            </box>
            <box class="acc-number-info">
                <box class="acc-name">{{(selectableData?.nickName) ? selectableData?.nickName : selectableData?.text.accountName }}</box>
                <span class="acc-number">{{selectableData?.text.accountNumber}}</span>
            </box>
        </box>
        <box class="account-sec-2">
            <box class="actual-balance">
                <span class="lbl1">Actual Balance</span>
                <span class="amount1 amount">{{ commonService.formatAmount(selectableData?.text.availableBalance) }} <em>{{ selectableData?.accountCurrency }}</em> <em>{{ selectableData?.text.accountCurrency
                        }}</em></span>
            </box>
            <ng-container *ngIf="selectableData.holdBalance && selectableData.holdBalance !='' && selectableData.holdBalance>0">
                <box class="h-seperator">&nbsp;</box>
                <box class="hold-balance">
                    <span class="lbl">Hold Balance</span>
                    <span class="amount">{{ commonService.formatAmount(selectableData?.text.holdBalance) }} <em>{{ selectableData?.accountCurrency }}</em> <em>{{ selectableData?.text.accountCurrency
                            }}</em></span>
                </box>
            </ng-container>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #loanListTmplt [appControlTemplate]="'loanListTmplt'">
    <box class="loan-list-item">
        <box class="loan-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/account-icon.svg" alt="account" />
            </box>
            <box class="loan-info">
                <box class="acc-number">{{selectableData?.text.accountNumber}}</box>
                <box class="acc-type-grp">
                    {{(selectableData?.text.nickName) ? selectableData.text.nickName : selectableData?.text.description }}

                </box>
            </box>
        </box>
        <box class="loan-sec-2">
            <box class="loan-type">
                <span class="lbl">Loan amount</span>
                <span class="amount">{{ selectableData?.text.loanAmount | currency : selectableData?.text.currency : '' }} <em>{{ selectableData?.text.currency
                        }}</em></span>
            </box>
            <box class="h-seperator">&nbsp;</box>
            <box class="outstanding">
                <span class="label">Outstanding</span>
                <span class="out-amount">{{ selectableData?.text.outstandingAmount | currency : selectableData?.text.currency : ''  }} <em>{{ selectableData?.text.currency
                        }}</em></span>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #depositaccountNumberListTmplt [appControlTemplate]="'depositaccountNumberListTmplt'">
    <box class="deposit-list-item">
        <box class="deposit-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/account-icon.svg" alt="account" />
            </box>
            <box class="acc-number-info">
                <box class="acc-number">{{ (selectableData?.nickName) ? selectableData?.nickName :selectableData.text.accountName }}</box>
                <span class="acc-type">{{ selectableData?.text.accountNumber }} / {{ selectableData?.text.description }}</span>
                <!-- <span class="acc-type"></span> -->
            </box>
        </box>
        <box class="deposit-sec-2">
            <box class="deposit-amount">
                <span class="lbl">Principal Amount</span>
                <span class="amount">{{ selectableData?.text.depositAmount | currency : selectableData?.text.currency : '' }}
                    <em>{{ selectableData?.text.currency }}</em></span>
            </box>
            <box class="h-seperator">&nbsp;</box>

            <box class="opened-date">
                <span class="lbl">Actual Deposit Date</span>
                <span class="date">{{ selectableData?.text.openDate  | date:  "dd/MM/yyyy" }}</span>
            </box>
        </box>
    </box>
</ng-template>

<ng-template let-selectableData #chequeNumberListTmplt [appControlTemplate]="'chequeNumberListTmplt'">
    <box class="account-list-item">
        <box class="account-sec-1">
            <box class="icon-wrapper">
                <img src="./assets/images/icons/cheque.svg" alt="cheque" />
            </box>
            <box class="acc-number-info">
                <span class="acc-cheque-number">{{selectableData?.text.chequeNumber}}</span>
                <box class="acc-customername">{{selectableData?.text.customerName}}</box>
            </box>
        </box>
        <box class="account-sec-2">
            <box class="cheque-amount">
                <span class="lbl">Cheque Amount</span>
                <span class="amount">{{ commonService.formatAmount(selectableData?.text.amount) }} <em>{{ selectableData?.text.currency}}</em> <em>{{ selectableData?.currency ||'USD' }}</em> </span>
            </box>
            <box class="h-seperator">&nbsp;</box>
            <box class="cheque-date">
                <span class="lbl">Cheque Date</span>
                <span class="amount">{{ selectableData?.text.issueDate }} </span>
            </box>
        </box>
    </box>
</ng-template>



<ng-template let-selectableData #beneListTmplt [appControlTemplate]="'beneListTmplt'">
  <box class="account-list-item">
      <box class="account-sec-1">
          <box class="icon-wrapper">
            <ng-container *ngIf="selectableData?.text?.icon; else noPhoto">
              <img *ngIf="selectableData?.text?.icon; else noPhoto" [src]="'./assets/images/trxicons/'+selectableData.icon" />
            </ng-container>
          <ng-template #noPhoto>
            <img  [src]="'./assets/images/icons/default-profile-pic.svg'">
              <!-- {{ selectableData.serviceCode?.charAt(0).toUpperCase() }} -->
          </ng-template>
          </box>
          <box class="acc-number-info">
            <box class="acc-name">{{selectableData?.text?.beneNickName}}</box>
            <ng-container *ngIf="selectableData.text.serviceCode == 'BENEINTBT'; else elseif1">
              <span class="acc-number">{{selectableData?.text?.beneIdentifier}}</span>
            </ng-container>
            <ng-template #elseif1>
              <ng-container *ngIf="selectableData.text.serviceCode == 'BENESWIFT'; else elseif2">
                <box class="acc-number">{{selectableData?.text?.beneIdentifier }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif2>
              <ng-container *ngIf="selectableData.text.serviceCode == 'BENEIFSC'; else elseif3">
                <box class="acc-number">{{selectableData?.text?.beneifsc?.accountNumber }}</box>
              </ng-container>
            </ng-template>
            <ng-template #elseif3>
                <ng-container *ngIf="selectableData.text.serviceCode == 'BENEDOMESTIC'; else elseif4">
                    <box class="acc-number bank-name">{{selectableData?.text?.beneBankIdentifier }}</box>
                  <box class="acc-number">{{selectableData?.text?.beneIdentifier }}</box>
                </ng-container>
              </ng-template>
            <ng-template #elseif4>
                <ng-container *ngIf="selectableData.text.serviceCode == 'BENEINTRAC'; else else1">
                    <ng-container *ngIf ="selectableData?.text?.beneintrac?.mobileNumber; else email">
                        <box class="acc-number">{{selectableData?.text?.beneintrac?.mobileNumber}}</box>
                      </ng-container>
                      <ng-template  #email><box class="acc-number">{{selectableData?.text?.beneintrac?.email }}</box>
                      </ng-template>
                </ng-container>
            </ng-template>


          </box>
      </box>
      <box class="account-sec-2">
          <!-- <box class="actual-balance">
              <span class="lbl">Actual Balance</span>
              <span class="amount">{{ commonService.formatAmount(selectableData?.text.actualBalance) }} <em>{{ selectableData?.currency ||'USD' }}</em> <em>{{ selectableData?.text.currency
                      }}</em></span>
          </box>
          <box class="h-seperator">&nbsp;</box>
          <box class="hold-balance">
              <span class="lbl">Hold Balance</span>
              <span class="amount">{{ commonService.formatAmount(selectableData?.text.holdBalance) }} <em>{{ selectableData?.currency ||'USD' }}</em> <em>{{ selectableData?.text.currency
                      }}</em></span>
          </box> -->
      </box>
  </box>
</ng-template>
